import { useIntl } from 'react-intl'
import CheckboxButton from 'LuxKit/Checkbox/CheckboxButton'
import ClickableListItem from 'LuxKit/List/ClickableListItem'

interface Props {
  isSelected?: boolean
  onClick?: () => void
}

function CruiseDepartureSelectListAll({ isSelected, onClick }: Props) {
  const intl = useIntl()

  const allDeparturePortsTitle = intl.formatMessage({
    id: 'cmzy850Y6pCLpg75cWSf',
    defaultMessage: 'All departure ports',
    description: 'Title for the option to select all cruise departure ports',
  })

  return <ClickableListItem
    onClick={onClick}
    title={<b>{allDeparturePortsTitle}</b>}
    endIcon={<CheckboxButton size="large" checked={isSelected} />}
  />
}

export default CruiseDepartureSelectListAll
